import React from 'react';
import { ShieldCheck, CalendarDays, RefreshCcw } from 'lucide-react';
import { useLang } from '../../context/LanguageContext';
import { GEO_LABELS } from '../../data/geo';

const fmt = (iso, lang) => {
  try {
    return new Date(iso).toLocaleDateString(lang === 'de' ? 'de-AT' : 'en-GB', { year: 'numeric', month: 'long', day: 'numeric' });
  } catch (_) { return iso; }
};

// Author / editorial review + publication and last-reviewed dates (E-E-A-T).
const AuthorMeta = ({ dates }) => {
  const { lang } = useLang();
  const L = GEO_LABELS[lang];
  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50 p-5">
      <p className="flex items-center gap-2 text-[13.5px] font-semibold text-slate-800">
        <ShieldCheck className="w-4 h-4 text-blue-700" /> {L.reviewedBy}
      </p>
      <p className="mt-1 text-[12.5px] text-slate-500">{L.editorialTeam}</p>
      {dates && (
        <div className="mt-3 flex flex-wrap gap-x-6 gap-y-1.5 text-[12px] text-slate-500">
          {dates.published && <span className="inline-flex items-center gap-1.5"><CalendarDays className="w-3.5 h-3.5" /> {L.published}: {fmt(dates.published, lang)}</span>}
          {dates.reviewed && <span className="inline-flex items-center gap-1.5"><RefreshCcw className="w-3.5 h-3.5" /> {L.lastReviewed}: {fmt(dates.reviewed, lang)}</span>}
        </div>
      )}
    </div>
  );
};

export default AuthorMeta;
